import { JOB_STATUSES } from '../config/jobConstants';
import { isJobOverdue, isJobDueToday } from '../utils/jobHelpers';

// Get job statistics
export const getJobStats = (jobs) => {
  const stats = {
    total: jobs.length,
    scheduled: 0,
    inProgress: 0,
    completed: 0,
    cancelled: 0,
    overdue: 0,
    dueToday: 0,
    totalRevenue: 0,
    averagePrice: 0
  };

  let totalPrice = 0;
  let priceCount = 0;

  jobs.forEach(job => {
    // Status counts
    if (job.status === JOB_STATUSES.SCHEDULED) stats.scheduled++;
    if (job.status === JOB_STATUSES.IN_PROGRESS) stats.inProgress++;
    if (job.status === JOB_STATUSES.COMPLETED) stats.completed++;
    if (job.status === JOB_STATUSES.CANCELLED) stats.cancelled++;
    
    // Timing
    if (isJobOverdue(job)) stats.overdue++;
    if (isJobDueToday(job)) stats.dueToday++;
    
    // Revenue
    if (job.price) {
      const price = parseFloat(job.price);
      totalPrice += price;
      priceCount++;
      if (job.status === JOB_STATUSES.COMPLETED) {
        stats.totalRevenue += price;
      }
    }
  });

  stats.averagePrice = priceCount > 0 ? totalPrice / priceCount : 0;

  return stats;
};